import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import type { PillarPageContent } from '../types/pillarPage';
type PerspectiveSectionProps = {
  content: PillarPageContent['perspective'];
};
export function PerspectiveSection({
  content
}: PerspectiveSectionProps) {
  return <section id="perspectiva" className="w-full bg-ink py-28 lg:py-40" data-id="element-189" data-mp="2mweurwetk0lz">
      <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 items-start gap-14 px-6 sm:px-10 lg:grid-cols-12 lg:gap-20" data-id="element-190" data-mp="1p84oh5802qp2">
        <div className="lg:col-span-7" data-id="element-191" data-mp="1u6fz3i64d58c">
          <Reveal data-id="element-192" data-mp="1u7hl2hoobc4u">
            <Eyebrow data-id="element-193" data-mp="1u92eu535yr1n">{content.eyebrow}</Eyebrow>
            <h2 className="mt-6 text-3xl font-extrabold leading-[1.1] tracking-[-0.025em] text-bone sm:text-4xl lg:text-[3.1rem]" data-id="element-194" data-mp="1z59a93xxok5c">
              {content.titleTop}
              <span className="block text-ash/70" data-id="element-195" data-mp="3alr9tcwtv2w7">{content.titleSub}</span>
            </h2>
          </Reveal>

          <div className="mt-10 max-w-xl space-y-6 text-[15px] leading-relaxed text-ash sm:text-base" data-id="element-196" data-mp="3emjjg79m39t0">
            {content.paragraphs.map((paragraph, i) => <Reveal key={paragraph} delay={0.05 + i * 0.03} data-id="element-197" data-mp="3tilh6r01xdd7" data-mpi={i}>
                <p data-id="element-198" data-mp="3omwg2j8dvoes">{paragraph}</p>
              </Reveal>)}
            <Reveal delay={0.14} data-id="element-199" data-mp="3jlyz29z410ev">
              <p className="text-bone" data-id="element-200" data-mp="3jl7676wwdgsa">{content.closingParagraph}</p>
            </Reveal>
          </div>

          <Reveal delay={0.18} data-id="element-201" data-mp="3fkddm08ifdt2">
            <div className="mt-12 border-l border-accent/30 pl-7" data-id="element-202" data-mp="3fn9gm2z7ssod">
              <p className="text-xl font-bold leading-snug tracking-[-0.01em] text-bone sm:text-2xl" data-id="element-203" data-mp="3anelfn8epgxi">
                {content.highlight.map((line, i) => <span key={line} className={i === 1 ? 'block text-accent' : 'block'} data-id="element-204" data-mp="30vha8gheeoys" data-mpi={i}>
                    {line}
                  </span>)}
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="lg:col-span-5" data-id="element-205" data-mp="2ru0z26ireiti">
          <figure className="relative overflow-hidden rounded-3xl border border-accent-deep/70 bg-surface" data-id="element-206" data-mp="2mw9b1nl8jgul">
            <img src={content.image} alt={content.imageAlt} className="h-[420px] w-full object-cover opacity-85 lg:h-[560px]" data-id="element-207" data-mp="2d8vki8l3z4v8" />
            <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(8,9,9,0.85),transparent_60%)]" aria-hidden="true" data-id="element-208" data-mp="23afq9wqsbfhi" />
            <figcaption className="absolute inset-x-0 bottom-0 p-7 text-[11px] font-medium uppercase tracking-label text-ash/80" data-id="element-209" data-mp="289sofdn3w8ze">
              {content.caption}
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>;
}